export default {
  ru: {
    title: "РЕМОНТ ЭЛЕКТРОДВИГАТЕЛЕЙ С ВСЫПНОЙ ОБМОТКОЙ",
    content: "<p class='py-2'>Наша компания предлагает услуги по ремонту низковольтных электродвигателей с всыпной обмоткой мощностью от 1 кВт до 320 кВт. В данную номенклатурную группу входят электрические двигатели с короткозамкнутым и фазным ротором общепромышленного назначения, крановые электродвигатели, а так же электродвигатели импортного производства.</p>"
  },
  en: {
    title: "REPAIR OF ELECTRIC MOTORS WITH BULK WINDING",
    content: "<p class='py-2'>Our company offers repair services for low-voltage electric motors with bulk winding power from 1 kW to 320 kW. This nomenclature group includes electric motors with short-circuited and phase rotor for general industrial purposes, crane electric motors, as well as electric motors of imported production.</p>"
  },
  ua: {
    title: "РЕМОНТ ЕЛЕКТРОДВИГУНІВ З ВСИПНОЮ ОБМОТКОЮ",
    content: "<p class='py-2'>Наша компанія пропонує послуги з ремонту низьковольтних електродвигунів з всипною обмоткою потужністю від 1 кВт до 320 кВт. До цієї номенклатурної групи входять електричні двигуни з короткозамкнутим і фазним ротором загальнопромислового призначення, кранові електродвигуни, й так само електродвигуни імпортного виробництва.</p>"
  },
}

